module.exports = __webpack_public_path__ + "img/Weapon_218.ecc91315.png";